import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import {
	BooleanField,
	CurrencyTextField,
	Form,
	SearchSelectField,
	useModel,
	useSettings,
	useUserData,
	Utils
} from 'app/main/components';

interface OrdersShippingChargesEditDialogProps {
	/** The base model */
	baseModel: any;
	/** If true the dialog is in add mode and not into edit */
	isAdd?: boolean;
	/** Function used to refresh the related view */
	updateRefresh?: VoidFunction;
}

export function showOrdersShippingChargesEditDialog(props: OrdersShippingChargesEditDialogProps) {
	return openDialog({
		children: <OrdersShippingChargesEditDialog {...props} />,
		fullWidth: true,
		maxWidth: 'sm',
		onClose: () => {}
	});
}

export default function OrdersShippingChargesEditDialog(props: OrdersShippingChargesEditDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('orders_shippingcharges');
	const userData = useUserData();

	const baseModel = { shch_uid: uuidv4(), shch_user_modified_uid: userData.user_uid, ...props.baseModel };
	const { model, sendChange, save } = useModel({ baseModel, settings, isEdit: true, isAdd: props.isAdd });

	const executeSave = () => {
		save({
			onSuccess: () => {
				dispatch(Utils.alertLocalizedMsg(t, 'ALERT_UPDATE_SUCCESS', 'success'));
				dispatch(closeDialog());
				props.updateRefresh?.();
			}
		});
	};

	return (
		<>
			<DialogTitle>{t(props.isAdd ? 'ORDERS_SHIPPINGCHARGES_ADD' : 'ORDERS_SHIPPINGCHARGES_UPDATE')}</DialogTitle>
			<DialogContent>
				<Form id="ordersShippingChargesEditDialog" onSubmit={executeSave}>
					<Grid container spacing={2}>
						{/* COUNTRY */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<SearchSelectField
								name="shch_ctry_id"
								label={t('DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_COUNTRY')}
								systable="countries"
								value={model.shch_ctry_id}
								isEdit
								sendChange={sendChange}
								required
							/>
						</Grid>
						{/*  VALUE */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<CurrencyTextField
								name="shch_value"
								label={t('DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_VALUE')}
								value={model.shch_value}
								isEdit
								sendChange={sendChange}
							/>
						</Grid>
						{/* TOT VALUE FROM */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<CurrencyTextField
								name="shch_tot_value_from"
								label={t('DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_TOT_VALUE_FROM')}
								value={model.shch_tot_value_from}
								isEdit
								sendChange={sendChange}
							/>
						</Grid>
						{/* TOT VALUE TO */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<CurrencyTextField
								name="shch_tot_value_to"
								label={t('DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_TOT_VALUE_TO')}
								value={model.shch_tot_value_to}
								isEdit
								sendChange={sendChange}
							/>
						</Grid>
						{/* DISABLED? */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<BooleanField
								name="shch_disabled"
								label={t('DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_DISABLED')}
								value={model.shch_disabled}
								isEdit
								sendChange={sendChange}
							/>
						</Grid>
					</Grid>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="ordersShippingChargesEditDialog" color="secondary">
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
